<div class="total-info" *ngIf="!graphLoading">
	${{totalInfo | number}}
</div>

<p-chart type="doughnut" #doughChart [data]="basicData" [options]="basicOptions">
</p-chart>

<lib-progress-spinner *ngIf="graphLoading"></lib-progress-spinner>
